module.exports = __webpack_public_path__ + "static/media/m24.588d56ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/merletto/m24.jpg
// module id = 445
// module chunks = 0